'use client'

import type { Didomi } from '@/util/analytics'

import { waitForTcfReady } from './tcf'

export type FreestarPrivacyFramework = 'none' | 'gpp' | 'tcf'

type PrivacyTarget = Pick<Window, '__gpp' | '__tcfapi'>

export function selectFreestarPrivacyFramework(didomi: Didomi): FreestarPrivacyFramework {
    let regulation: string | undefined
    try {
        regulation = didomi.getCurrentUserStatus?.().regulation
    } catch {
        return 'gpp'
    }

    switch (regulation?.trim().toUpperCase()) {
        case 'GDPR':
            return 'tcf'
        case 'NONE':
            return 'none'
        default:
            return 'gpp'
    }
}

export function waitForFreestarPrivacyReady(didomi: Didomi, target: PrivacyTarget = window): Promise<void> {
    const framework = selectFreestarPrivacyFramework(didomi)
    if (framework === 'tcf') {
        return waitForTcfReady(target)
    }

    // Freestar remains behind the rollout flag. Keep GPP observable, but do not
    // turn incomplete Didomi GPP setup into a load gate until the rollout ends.
    return Promise.resolve()
}
